import React, { useEffect, useMemo } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type ManageSocialAccountsFieldsProps = {
  instagram?: string;
  linkedin?: string;
  personalWebsite?: string;
  twitter?: string;
  facebook?: string;
  other?: string;
};
const ManageSocialAccountsFields = (props: ManageSocialAccountsFieldsProps) => {
  const { instagram, linkedin, personalWebsite, twitter, facebook, other } =
    props;

  const [instagramValue, setInstagramValue] = React.useState(instagram || '');
  const [linkedInValue, setLinkedInValue] = React.useState(linkedin || '');
  const [personalWebsiteValue, setPersonalWebsiteValue] = React.useState(
    personalWebsite || ''
  );
  const [xValue, setXValue] = React.useState(twitter || '');
  const [facebookValue, setFacebookValue] = React.useState(facebook || '');
  const [otherValue, setOtherValue] = React.useState(other || '');

  useEffect(() => {
    setInstagramValue(instagram || '');
    setLinkedInValue(linkedin || '');
    setPersonalWebsiteValue(personalWebsite || '');
    setXValue(twitter || '');
    setFacebookValue(facebook || '');
    setOtherValue(other || '');
  }, [instagram, linkedin, personalWebsite, twitter, facebook, other]);

  const socialMediaFields = useMemo(
    () => [
      {
        label: 'Instagram',
        url: 'https://instagram.com/',
        value: instagramValue,
        setState: setInstagramValue,
      },
      {
        label: 'LinkedIn',
        url: 'https://linkedin.com/in/',
        value: linkedInValue,
        setState: setLinkedInValue,
      },
      {
        label: 'Personal Website',
        url: 'https://youtube.com/user/',
        value: personalWebsiteValue,
        setState: setPersonalWebsiteValue,
      },
      {
        label: 'Twitter',
        url: 'https://twitter.com/',
        value: xValue,
        setState: setXValue,
      },
      {
        label: 'Facebook',
        url: 'https://facebook.com/',
        value: facebookValue,
        setState: setFacebookValue,
      },
      {
        label: 'Other',
        url: 'https://',
        value: otherValue,
        setState: setOtherValue,
      },
    ],
    [
      instagramValue,
      linkedInValue,
      personalWebsiteValue,
      xValue,
      facebookValue,
      otherValue,
    ]
  );

  return (
    <Grid spacing={3} p={5}>
      {socialMediaFields.map((field, index) => (
        <Grid key={index} item xs={12}>
          <Typography
            variant='body1'
            sx={{
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000',
              marginBottom: 1,
            }}>
            {field.label}
          </Typography>
          <Box display='flex' alignItems='center'>
            <Typography
              sx={{
                color: '#666',
                marginRight: 1,
                whiteSpace: 'nowrap',
                width: '180px',
              }}>
              {field.url}
            </Typography>
            <Box sx={{ flexGrow: 1 }}>
              <CustomTextField
                name={field.label}
                sx={{ width: '100%', maxWidth: '654px' }}
                value={field.value}
                // defaultValue={"firstName" || ""}
                // onChange={function (
                //   e: React.ChangeEvent<HTMLInputElement>
                // ): void {
                //   field.setState(e.target.value);
                //   // throw new Error("Function not implemented.");
                // }}
                onChange={() => {}}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ManageSocialAccountsFields;
